/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbSyncLogSortCriteria {
    getFixupPrototypeFunction() { return ServiceNowCmdbSyncLogSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbSyncLogSortCriteria>): ServiceNowCmdbSyncLogSortCriteria {
        let obj = Object.assign(new ServiceNowCmdbSyncLogSortCriteria(), model);
        ServiceNowCmdbSyncLogSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbSyncLogSortCriteria>): ServiceNowCmdbSyncLogSortCriteria {
        if (!model) return null;
        return ServiceNowCmdbSyncLogSortCriteria.newInstance(<ServiceNowCmdbSyncLogSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbSyncLogSortCriteria) {
        if (!obj) return;

        models.ServiceNowCmdbSyncLogSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbSyncLogSortCriteria): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbSyncLogSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.ServiceNowCmdbSyncLogSortColumn;

    ascending: boolean;

}
